import { render } from "./PardehHawa.vue?vue&type=template&id=55cbf953"
import script from "./PardehHawa.vue?vue&type=script&lang=js"
export * from "./PardehHawa.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/touran-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__